import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from 'lib/api';
import { get_operations } from 'lib/patch';
import { ASSESSMENT_TYPES } from '../components/BlockAssessments/AssessmentTypes';
export var GET_BLOCK_TYPES = 'BLOCKS_GET_BLOCK_TYPES';
export var CLEAR_BLOCK_TYPES = 'BLOCK_CLEAR_BLOCK_TYPES';
export var SAVE_BLOCKS_ON_REFERENCE = 'BLOCKS_SAVE_BLOCKS_ON_REFERENCE';
export var CREATE_ASSESSMENT_BLOCK = 'BLOCKS_CREATE_ASSESSMENT_BLOCK';
export var UPDATE_ASSESSMENT_BLOCK = 'BLOCKS_UPDATE_ASSESSMENT_BLOCK';
export var UPDATE_BLOCKS_ON_REFERENCE = 'BLOCKS_UPDATE_BLOCKS_ON_REFERENCE';
export var GET_BLOCKS_BY_REFERENCE = 'BLOCKS_GET_BLOCKS_BY_REFERENCE';
export var CLEAR_BLOCKS_ON_REFERENCE = 'BLOCKS_CLEAR_BLOCKS_ON_REFERENCE';
export var DELETE_BLOCK = 'BLOCKS_DELETE_BLOCK';
export var getBlockTypes = function getBlockTypes() {
  return {
    type: GET_BLOCK_TYPES,
    payload: new Promise(function (resolve, reject) {
      return api.get("blocks/types").then(function (response) {
        if (response.status > 300) {
          reject(null);
          return true;
        }

        resolve(response.data);
      });
    })
  };
};
export var clearBlockTypes = function clearBlockTypes() {
  return {
    type: CLEAR_BLOCK_TYPES,
    payload: true
  };
};
export var saveBlocksOnReference = function saveBlocksOnReference(blocks, referenceId, referenceType) {
  return {
    type: SAVE_BLOCKS_ON_REFERENCE,
    payload: new Promise(function (resolve, reject) {
      var values = JSON.parse(JSON.stringify(blocks)).map(function (block) {
        block.referenceId = referenceId;
        block.referenceType = referenceType;
        return block;
      });
      api.post("blocks", values).then(function (response) {
        if (response.status > 300) {
          reject(null);
          return true;
        }

        resolve(response.data);
      });
    })
  };
};
export var updateBlocksOnReference = function updateBlocksOnReference(blocks, referenceId, referenceType) {
  return {
    type: UPDATE_BLOCKS_ON_REFERENCE,
    payload: new Promise(function (resolve, reject) {
      var values = JSON.parse(JSON.stringify(blocks)).map(function (block) {
        block.referenceId = referenceId;
        block.referenceType = referenceType;
        return block;
      });
      api.put("blocks", values).then(function (response) {
        if (response.status > 300) {
          reject(null);
          return true;
        }

        resolve(response.data);
      });
    })
  };
};
export var clearBlocksOnReference = function clearBlocksOnReference() {
  return {
    type: CLEAR_BLOCKS_ON_REFERENCE,
    payload: true
  };
};
export var getBlocksByReference = function getBlocksByReference(referenceId, referenceType) {
  return {
    type: GET_BLOCKS_BY_REFERENCE,
    payload: new Promise(function (resolve, reject) {
      api.get("blocks?referenceId=".concat(referenceId, "&referenceType=").concat(referenceType)).then(function (response) {
        if (response.status > 300) {
          reject(null);
          return true;
        }

        resolve(response.data);
      });
    })
  };
};
export var deleteBlock = function deleteBlock(blockId) {
  return {
    type: DELETE_BLOCK,
    payload: new Promise(function (resolve, reject) {
      api["delete"]("blocks/".concat(blockId)).then(function (response) {
        if (response.status > 300) {
          reject(response.data);
          return true;
        }

        resolve(response.data);
      });
    })
  };
};

var createAssessmentPart = function createAssessmentPart(resource, courses) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
      var partValue, goal, part;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              partValue = resource;

              if (!(resource.referenceType == 'assessmentGoal')) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return api.post('assessmentGoals', resource.value);

            case 4:
              goal = _context.sent;
              partValue = {
                referenceType: resource.referenceType,
                referenceId: goal.data.id,
                permissions: partValue.permissions,
                originId: resource.originId,
                assessmentBlockPartRows: goal.data.rows.map(function (row) {
                  return {
                    referenceType: 'assessmentGoalRow',
                    referenceId: row.id
                  };
                }),
                assessmentBlockPartRelationships: courses.map(function (courseId) {
                  return {
                    courseId: courseId
                  };
                }),
                assessmentType: resource.assessmentType
              };

            case 6:
              if (resource.referenceType == 'matrix') {
                // Delete stored course object from resource before sending to API
                delete partValue.value;
              }

              _context.next = 9;
              return api.post('assessmentParts', partValue);

            case 9:
              part = _context.sent;
              resolve(part.data);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

var updateAssessmentPart = function updateAssessmentPart(resource, oldResource, courses) {
  return new Promise( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
      var part, goal, oldGoal, _operations, operations, filteredOperations;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(resource.id == null || oldResource == null)) {
                _context2.next = 4;
                break;
              }

              part = createAssessmentPart(resource, courses);
              resolve(part);
              return _context2.abrupt("return", true);

            case 4:
              if (!(resource.referenceType == 'assessmentGoal')) {
                _context2.next = 11;
                break;
              }

              goal = resource.value;
              oldGoal = oldResource.value;
              _operations = get_operations(oldGoal, goal);

              if (!(_operations.length > 0)) {
                _context2.next = 11;
                break;
              }

              _context2.next = 11;
              return api.patch("assessmentGoals/".concat(resource.referenceId), oldResource, _operations);

            case 11:
              delete resource.value;
              delete oldResource.value;
              resource.assessmentBlockPartRelationships = courses.map(function (courseId) {
                var foundRelationship = oldResource.assessmentBlockPartRelationships.find(function (rel) {
                  return rel.courseId == courseId;
                });

                if (foundRelationship != null) {
                  return foundRelationship;
                }

                return {
                  courseId: courseId
                };
              });
              operations = get_operations(oldResource, resource);

              if (!(operations != null && operations.length > 0)) {
                _context2.next = 20;
                break;
              }

              /** We dont need to add any assessmentblockrelationships for matrices. For assessmentGoals the relationships is added above. */
              filteredOperations = operations.filter(function (item) {
                return !(item.op == "add" && item.path == "/assessmentBlockPartRelationships");
              });

              if (!(filteredOperations.length > 0)) {
                _context2.next = 20;
                break;
              }

              _context2.next = 20;
              return api.patch("assessmentParts/".concat(resource.id), oldResource, filteredOperations);

            case 20:
              resolve(resource);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};

export var createAssessmentBlock = function createAssessmentBlock(block, referenceId, referenceType) {
  return {
    type: CREATE_ASSESSMENT_BLOCK,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
        var _values$resources$fil;

        var values, resources, courses, typeResource;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                values = JSON.parse(JSON.stringify(block));
                resources = [];
                courses = [];
                values.resources.forEach(function (resource) {
                  if (resource.referenceType == 'matrix') {
                    courses.push(resource.value.id);
                  }
                });
                typeResource = (_values$resources$fil = values.resources.filter(function (resource) {
                  return resource['@odata.type'] == 'assessmenttype';
                })[0]) === null || _values$resources$fil === void 0 ? void 0 : _values$resources$fil.value;
                values.resources = values.resources.filter(function (resource) {
                  return resource['@odata.type'] != 'assessmenttype';
                });
                values.resources.forEach(function (resource) {
                  resource.assessmentType = typeResource == null ? ASSESSMENT_TYPES.TEACHER : typeResource;
                });
                values.assessmentType = typeResource == null ? ASSESSMENT_TYPES.TEACHER : typeResource;
                _context4.next = 10;
                return Promise.all(values.resources.map(function (resource) {
                  return new Promise( /*#__PURE__*/function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
                      var part;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              if (!(resource['@odata.type'] == 'Haldor.Blocks.AssessmentBlockPart')) {
                                _context3.next = 7;
                                break;
                              }

                              _context3.next = 3;
                              return createAssessmentPart(resource, courses);

                            case 3:
                              part = _context3.sent;
                              resources.push({
                                '@odata.type': 'Haldor.Blocks.AssessmentBlockPart',
                                id: part.id,
                                assessmentType: resource.assessmentType
                              });
                              resolve(resource);
                              return _context3.abrupt("return", true);

                            case 7:
                              resources.push(resource);
                              resolve(resource);

                            case 9:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function (_x4) {
                      return _ref4.apply(this, arguments);
                    };
                  }());
                }));

              case 10:
                values.type = 'Haldor.Blocks.AssessmentBlock';
                values.resources = resources;
                values.referenceId = referenceId;
                values.referenceType = referenceType;
                api.post('blocks', [values]).then(function (response) {
                  resolve(response.data);
                });

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }())
  };
};
export var updateAssessmentBlock = function updateAssessmentBlock(block, oldBlock) {
  return {
    type: UPDATE_ASSESSMENT_BLOCK,
    payload: new Promise( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve) {
        var values, resources, courses, deletedResources;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                values = JSON.parse(JSON.stringify(block));
                resources = [];
                courses = [];
                values.resources.forEach(function (resource) {
                  if (resource.referenceType == 'matrix') {
                    courses.push(resource.value.id);
                  }
                });
                deletedResources = oldBlock.resources.filter(function (item) {
                  return !values.resources.find(function (currentItem) {
                    return currentItem.id == item.id;
                  });
                });

                if (!(deletedResources != null && deletedResources.length > 0)) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return Promise.all(deletedResources.map(function (resource) {
                  return new Promise( /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
                      var operations;
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (!(resource['@odata.type'] == 'Haldor.Blocks.AssessmentBlockPart')) {
                                _context5.next = 8;
                                break;
                              }

                              delete resource.index;
                              operations = [{
                                op: 'remove',
                                path: '/',
                                value: resource
                              }];
                              resource.assessmentBlockPartRelationships.map(function (relationship) {
                                operations.push({
                                  op: 'remove',
                                  path: '/assessmentBlockPartRelationships',
                                  value: relationship
                                });
                              });
                              _context5.next = 6;
                              return api.patch("assessmentParts/".concat(resource.id), resource, operations);

                            case 6:
                              resolve(resource);
                              return _context5.abrupt("return", true);

                            case 8:
                              resolve(resource);

                            case 9:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function (_x6) {
                      return _ref6.apply(this, arguments);
                    };
                  }());
                }));

              case 8:
                _context7.next = 10;
                return Promise.all(values.resources.map(function (resource) {
                  return new Promise( /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolve) {
                      var _resource$assessmentT, oldResource, part;

                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              if (!(resource['@odata.type'] == 'Haldor.Blocks.AssessmentBlockPart')) {
                                _context6.next = 9;
                                break;
                              }

                              delete resource.index;
                              oldResource = oldBlock.resources.find(function (res) {
                                return res.id == resource.id;
                              });
                              _context6.next = 5;
                              return updateAssessmentPart(resource, oldResource, courses);

                            case 5:
                              part = _context6.sent;
                              resources.push({
                                '@odata.type': 'Haldor.Blocks.AssessmentBlockPart',
                                id: part.id,
                                assessmentType: (_resource$assessmentT = resource.assessmentType) !== null && _resource$assessmentT !== void 0 ? _resource$assessmentT : ASSESSMENT_TYPES.TEACHER
                              });
                              resolve(resource);
                              return _context6.abrupt("return", true);

                            case 9:
                              resources.push(resource);
                              resolve(resource);

                            case 11:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function (_x7) {
                      return _ref7.apply(this, arguments);
                    };
                  }());
                }));

              case 10:
                resources = resources.filter(function (resource) {
                  return resource.id != null;
                });
                values.resources = resources;
                values.referenceId = oldBlock.referenceId;
                values.referenceType = oldBlock.referenceType;
                api.put('blocks', [values]).then(function (response) {
                  resolve(response.data);
                });

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }())
  };
};